import React from 'react';
import Page from '../page';
import { Redirect } from 'react-router-dom';

const Thanks = ({
  mps,
  parties,
  title,
  name,
  lead,
  thanksStepContent,
  shareUrl,
  sendEmailComplete,
  userInput: { selectedMPId, firstName }
}) => {
  if (!sendEmailComplete) {
    return <Redirect to="/" />;
  }

  const selectedMP = mps.find((mp) => mp.id === selectedMPId);
  const selectedMPParty = parties.find((p) => p.id === selectedMP.partyId);
  const infoPanel = (
    <div dangerouslySetInnerHTML={{ __html: thanksStepContent }} />
  );

  const header = (
    <h2 className="h4 mb-0 text-uppercase text-center">Increase your impact</h2>
  );

  const twitterShareText = `I just emailed ${selectedMP.name} from ${selectedMPParty.name} about ${name}. You should email your MP too! @actionstation have made it really easy to do`;

  return (
    <Page
      header={header}
      title={title}
      lead={lead}
      infoPanel={infoPanel}
      cardTitle="Thanks"
    >
      <h3 className="h5 mb-3">
        Double your impact by asking your friends and family to write too.
      </h3>
      <div className="row mb-3">
        <div className="col-8 offset-2">
          <a
            className="btn btn-outline-redpink btn-block"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
          >
            <i className="fab fa-facebook" /> Share on Facebook
          </a>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-8 offset-2">
          <a
            className="btn btn-outline-redpink btn-block"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://twitter.com/intent/tweet?text=${twitterShareText}&url=${shareUrl}`}
          >
            <i className="fab fa-twitter" /> Share on Twitter
          </a>
        </div>
      </div>
      <p>
        <i className="fas fa-envelope" /> Copy this text into an email to share
        with your friends
      </p>
      <div className="small card-text border rounded p-3">
        <p>Hey!</p>
        <p>
          I just emailed {selectedMP.name} about {name} and I’m hoping you will
          join me in taking action too.
        </p>
        <p>
          ActionStation have set up a tool that makes it really easy to do:{' '}
          <a href={shareUrl}>{shareUrl}</a>
        </p>
        <p className="mb-0">
          Thanks!
          <br />
          {firstName}
        </p>
      </div>
    </Page>
  );
};

export default Thanks;
